<template>
  <div>
    <transition :name="transitionName" mode="out-in" type="animation">
      <!--<keep-alive exclude="subscriber" max="20">-->
      <!--<component          :is="selectedComponent"          @subscriptionClick="enterSubscription($event)"          @backClick="goBack()"          class="componentsBox"          :subscriptionId="subscriptionId"        >        </component>-->
      <!-- router-view renderea el componente que corresponde segun el route -->
      <router-view
        @subscriptionClick="enterSubscription($event)"
        :subscriptionId="subscriptionId"
      ></router-view>
      <!--</keep-alive>-->
    </transition>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
export default {
  data() {
    return {
      subscriptionId: null,
      loading: false,
      transitionName: "",
      selectedComponent: ""
    };
  },
  methods: {
    ...mapActions({
      loadSubscriptions: "subscriptions/load",
      saveSubscription: "subscriptions/save",
      addSubscription: "subscriptions/add",
      deleteSubscription: "subscriptions/delete"
    }),
    enterSubscription(subscriptionId) {
      this.subscriptionId = subscriptionId;
      this.selectedComponent = "subscriptionDetails";
      this.transitionName = "slide-left";
    },
    goBack() {
      this.selectedComponent = "subscriptionsTable";
      this.transitionName = "slide-right";
    },
    defineTransition() {
      if (this.$route.path.indexOf("subscriptions/") === -1) {
        this.transitionName = "slide-left";
        this.selectedComponent = "subscriptionsList";
      } else {
        this.transitionName = "slide-right";
        this.selectedComponent = "subscriptionDetails";
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    //si no tiene nada despues del ultimo segmento de la url,viene desde /subscriptions. Si si tiene viene de /subscriptions/3
    this.transitionName =
      from.path.split("/")[2] == "" ? "slide-right" : "slide-left";
    /*const toDepth = to.path.split("/").length;    const fromDepth = from.path.split("/").length;    this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";*/

    this.defineTransition();
    next();
  },
  mounted() {
    this.defineTransition();
  }
};
</script>

<style scoped>
.slide-left-enter-to {
  /*transition: opacity 0.2s;  opacity: 1;*/
}
.slide-left-enter-active {
  animation: slide-in-left 0.1s ease-in-out;
}
.slide-left-leave {
}
.slide-left-leave-to {
  /*transition: opacity 0.1s;  opacity: 0;*/
}
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out;
}
@keyframes slide-in-left {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slide-out-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
.slide-right-enter-to {
  /*transition: opacity 0.2s;  opacity: 1;*/
}
.slide-right-enter-active {
  animation: slide-in-right 0.2s ease-in-out forwards;
}
.slide-right-leave {
}
.slide-right-leave-to {
  /*transition: opacity 0.2s;  opacity: 0;*/
}
.slide-right-leave-active {
  animation: slide-out-right 0.1s ease-in-out forwards;
}
@keyframes slide-in-right {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slide-out-right {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}
</style>
